import { render, staticRenderFns } from "./UserReservationOrderList.vue?vue&type=template&id=5751a64a&"
import script from "./UserReservationOrderList.vue?vue&type=script&lang=js&"
export * from "./UserReservationOrderList.vue?vue&type=script&lang=js&"
import style0 from "./UserReservationOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports